/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "685885b9be25515acf38c3c1e38718c6d2813ac0";
